import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-additional-fields-add-dialog',
  templateUrl: './additional-fields-add-dialog.component.html',
  styleUrls: ['./additional-fields-add-dialog.component.scss']
})
export class AdditionalFieldsAddDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AdditionalFieldsAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdditionalFieldsAddDialogComponent,
  ) { }

  ngOnInit(): void {
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
